<div class="upload-queue-head-root" *transloco="let t">
  <div class="upload-queue-grid">
    <app-label class="header" isBig>{{t(labels.file)}}</app-label>
    <app-label class="header" isBig>{{t(labels.status)}}</app-label>
    <app-label class="header" isBig>{{t(labels.date)}}</app-label>
    <app-label class="header" isBig>{{t(labels.report)}}</app-label>
    <ng-container *ngFor="let migrationFile of files">
      <app-label class="file name"
                 [title]="migrationFile.name">
        {{migrationFile.name}}
      </app-label>
      <div *ngIf="!hasProgress(migrationFile)" class="file status">
        <app-label [ngClass]="fileStatusClass(migrationFile)"
                   class="file status"
                   [title]="t(fileStatusText(migrationFile.status))">
          {{t(fileStatusText(migrationFile.status))}}
        </app-label>
        <app-icon-click
          class="upload-action"
          flat
          *ngIf="canRetry(migrationFile)"
          [title]="t(labels.retry)"
          (click)="_retry(migrationFile)">
          restart_alt
        </app-icon-click>
      </div>
      <div *ngIf="hasProgress(migrationFile)" class="file status">
        <mat-progress-bar mode="determinate"
                          [title]="migrationFile.progress | number: '1.0-0'"
                          [value]="migrationFile.progress">
        </mat-progress-bar>
        <app-icon-click
          flat
          *ngIf="canCancel(migrationFile)"
          class="upload-action"
          [title]="t(labels.cancel)"
          (click)="cancel(migrationFile)">
          cancel
        </app-icon-click>
      </div>
      <app-label class="file date"
                 [title]="migrationFile.creationDate | lnrDate">
        {{migrationFile.creationDate | lnrDate}}
      </app-label>
      <app-secondary-button [title]="t(labels.download)"
                            class="file report"
                            [disabled]="!canDownloadReport(migrationFile)"
                            (clickAction)="emitDownloadReport(migrationFile)"
                            auxiliaryBlue>
        {{t(labels.download)}}
      </app-secondary-button>
    </ng-container>
  </div>
  <div *ngIf="loading" class="loading">
    <mat-spinner diameter="75"></mat-spinner>
  </div>
  <!-- TODO(EL-2030): replace following `false` with `moreFilesAvailable` -->
  <app-anchor *ngIf="false">{{t(labels.checkUploadHistory)}}</app-anchor>
</div>
